import HotelImportModel from "./HotelImportModel";

export default class HotelsImportPreviewResultModel {
    public static Create(obj?: Partial<HotelsImportPreviewResultModel>) {
        return Object.assign(new HotelsImportPreviewResultModel(), obj ?? {}, {
            hotels: (obj?.hotels ?? []).map(x => HotelImportModel.Create(x)),
        })
    }

    isOk: boolean = true
    errorMessage: string = ''
    countOk: number = 0
    countDuplicates: number = 0
    countErrors: number = 0
    hotels: HotelImportModel[] = []
}
